"use strict";

/*eslint-disable*/module.exports = {
  messages: {
    "Do you have additional feedback about this information?": "Você tem mais comentários sobre essas informações?",
    "It didn't address my needs": "Não atendeu às minhas necessidades",
    "It wasn't what I was looking for": "Não era o que eu estava procurando",
    "NOTE: Your comments here can only be seen by our editor": "OBSERVAÇÃO: Seus comentários aqui só podem ser vistos pelo editor",
    "No": "Não",
    "Please tell us why": "Diga-nos por quê",
    "Something else": "Outra coisa",
    "Submit feedback": "Enviar comentários",
    "Thank you. We've recorded your feedback.": "Obrigado. Gravamos seu feedback.",
    "The information was difficult to understand": "A informação era difícil de entender",
    "Was this information helpful?": "Essas informações foram úteis?",
    "Why wasn't this information helpful?": "Por que essas informações não foram úteis?",
    "Yes": "Sim"
  }
};